import * as _ from 'lodash';
import * as React from 'react';

import { Formatters } from '../common/formatters';

export default class CellTextInput extends React.Component<any, any> {
    public constructor(props: any) {
        super(props);

        this.state = {
            value: _.get(props.dataItem, props.field, ''),
        };
    }

    public componentWillReceiveProps(nextProps: any) {
        const wasEditing = Formatters.getBool(this.props.dataItem, this.props.recordEditingField);
        const isEditing = Formatters.getBool(nextProps.dataItem, nextProps.recordEditingField);
        const currentId = Formatters.getStr(this.props.dataItem, '_id');
        const nextId = Formatters.getStr(nextProps.dataItem, '_id');

        if (!isEditing
            || currentId !== nextId
            || this.props.field !== nextProps.field
            || (!wasEditing && isEditing)) {
            this.setState({
                value: _.get(nextProps.dataItem, nextProps.field, ''),
            });
        }
    }

    public render() {
        const { dataItem, field, handleInputChange, handleInputCommit, recordEditingField, ...rest } = this.props;
        const isEditing = Formatters.getBool(dataItem, recordEditingField);

        if (!isEditing) {
            return (
                <td>
                    {Formatters.getStr(dataItem, field)}
                </td>
            );
        }

        return (
            <td>
                <input
                    className="k-textbox"
                    style={{ width: '100%' }}
                    value={this.state.value || ''}
                    onChange={(e: any) => {
                        const value = _.get(e, 'target.value', '');
                        this.setState({ value });

                        if (handleInputChange) {
                            handleInputChange({
                                dataItem,
                                field,
                                syntheticEvent: e,
                                value,
                            });
                        }
                    }}
                    onBlur={(e: any) => {
                        if (handleInputCommit) {
                            handleInputCommit({
                                dataItem,
                                field,
                                syntheticEvent: e,
                                value: this.state.value || '',
                            });
                        }
                    }}
                />
            </td>
        );
    }
}



// WEBPACK FOOTER //
// ./src/lookup-tables/cell-text-input.tsx